import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'


const MenuItems = ({title, to, iconClassName, SubMenus, onClick}) => {
    const [expand, setExpand] = useState(false)
    return (
        <li onClick={onClick}>
            <NavLink to={to} className="menu-item" onClick={() => setExpand(!expand) }>
                <div className="menu-icon">
                    <i className={iconClassName}></i>
                </div>
                <span>{title}</span>
            </NavLink>
            {
                SubMenus && SubMenus.length > 0 ? <ul className={`sub-menu ${expand ? 'active' : '' }`}>
                    {
                        SubMenus.map((menu, idx) => {
                            return (<li key={idx}>
                                <NavLink to={menu.to}><span>{menu.title}</span></NavLink>
                            </li>)
                        })
                    }
                </ul> : null
            }
        </li>
    )
}

export default MenuItems
